export const onFilterElemClick = ($elem, _this, text = $elem.text()) => {
  const $parent = $elem.parents(".vbw-filters--container");
  const filterId = $parent.find(".filters-dropdown").attr("id");
  const filterHeader = $elem
    .parent()
    .parent()
    .find("#" + filterId + "-text", "#" + filterId + "-text-mobile");
  _this.filters[filterId] = $elem.attr("value");
  filterHeader.text(text);

  $elem.siblings().removeClass("active");
  $elem.addClass("active");
  $elem.parents(".vbw-filters--container").addClass("filter-active");

  $(".vbw-filters--container").each(function () {
    $(this).removeClass("active");
  });
};

export const clearFilterDesktop = ($elem, _this) => {
  const $parent = $elem.parents(".vbw-filters--container");
  const filterId = $parent.find(".filters-dropdown").attr("id");

  $parent.removeClass("active");
  $parent.removeClass("filter-active");
  $parent
    .find(".filters-dropdown-head-text")
    .text(
      $parent.find(".filters-dropdown-head-text").attr("data-original-text")
    );
  $parent.find(".dropdown-li").removeClass("active");
  _this.filters[filterId] = undefined;

  _this.applyFilters();
  //condition for global schedule filters
  if (_this.applyCompetitionFilters !== undefined)
    _this.applyCompetitionFilters()
};

export const resetFilterMobile = ($elem, _this) => {
  $elem.find(".filters-dropdown-head-text").each(function () {
    $(this).text($(this).attr("data-original-text"));
    $(this).removeClass("active");
  });

  $elem.find(".dropdown-li").each(function () {
    $(this).removeClass("active");
  });
  _this.filters = {};
};

export const onFilterHeadClick = ($elem, _this) => {
  if ($elem.parent().hasClass("active")) {
    $elem.parent().removeClass("active");
  } else {
    $(".vbw-filters--container").each(function () {
      $(this).removeClass("active");
    });
    $elem.parent().addClass("active");
  }
};

export const closeAllDropdowns = () => {
  $(".vbw-filters--container").each(function () {
    $(this).removeClass("active");
  });
};

export const onSearchInputChange = ($elem, _this) => {
  const searchText = $elem.val();
  if (searchText.length > 0) {
    _this.filters["filters-searchBox"] = searchText;
    _this.applyFilters();
  } else {
    _this.filters["filters-searchBox"] = undefined;
    _this.applyFilters();
  }
};

export const sortAlphabetically = (items) => {
  return items.sort((a, b) => {
    if (a < b) {
      return -1;
    }
    if (a > b) {
      return 1;
    }
    return 0;
  });
};

export const updateFilterCounter = (count) => {
  if (count == 0) {
    $(".vbw-competitions-filters--icon")
      .find(".vbw-filter-active-count")
      .hide();
  } else {
    $(".vbw-competitions-filters--icon")
      .find(".vbw-filter-active-count")
      .show()
      .text(count);
  }
};
